import React, { useState, useEffect, useRef } from 'react';
import './anim.css';

export const FadeInSection = ({ children, animationType = 'up', csClass = ""}) => {
    const [isVisible, setVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const onIntersect = (entries) => {
            const [entry] = entries;
            if (entry.isIntersecting) {
                setVisible(true);
            }
        };

        const observer = new IntersectionObserver(onIntersect, {
            threshold: 0.35, // Trigger when 35% visible
        });

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    // Map the animationType to the corresponding class
    const animationClassMap = {
        up: 'animate-fadingUp',
        down: 'animate-fadingDown',
        left: 'animate-fadingLeft',
        right: 'animate-fadingRight',
        superLeft: 'animate-superLeft',
    };

    const animationClass = animationClassMap[animationType] || 'animate-fadingUp'; // Default to 'up'

    return (
        <div
            ref={sectionRef}
            className={`fade-in-section ${isVisible ? animationClass : 'opacity-0'} ${csClass}`}
        >
            {children}
        </div>
    );
};

export default FadeInSection;
